import { connect } from 'react-redux';
import PrivacyPolicy from './PrivacyPolicy';
import { isAuthenticated } from '../../../state/reducers/LoginReducer';

export default connect((state) => ({
  isAuthenticated: isAuthenticated(state),
}))(PrivacyPolicy);



// WEBPACK FOOTER //
// ./src/view/forms/PrivacyPolicy/index.js